// @flow
import * as React from 'react';
import styled from 'styled-components';
import colors from '../../assets/css/colors';
import { below } from "../../assets/css/media";


const ModalHeaderStyled = styled.div`
	background: ${colors.nrlDarkGreen};
	height: 110px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 20px;
	box-sizing: border-box;

	${below.tablet`
		height: 70px;
	`}

	@media only screen and (max-height: 400px) {
		height: 50px;
	}
`;

const ModalHeaderTitle = styled.h2`
	color: #FFFFFF;
	font-size: 30px;
	font-weight: 900;
	line-height: 1.76;

	${below.tablet`
		font-size: 24px;
		max-width: 300px;
	`}

	@media only screen and (max-height: 400px) {
		font-size: 20px;
	}
`;

type Props = {
	header_text?: string,
	is_sponsored?: boolean
};

export const ModalHeader = ({ header_text, is_sponsored }: Props) => (
	<ModalHeaderStyled>
		{header_text ? (
			<ModalHeaderTitle>
				{header_text}
			</ModalHeaderTitle>
		) : null}

	</ModalHeaderStyled>
);

export default ModalHeader;


// WEBPACK FOOTER //
// ./src/components/Modal/ModalHeader.js